import { IProgram } from '@shared/interface/model.interface'
import { dbData } from './init.db.data'
import { logger } from '@shared/lib/logger/logger-manager'

// ********************************************************
// Table 'program'
// ********************************************************
// ****************************************************************************** GET
interface IDbGetProgramParam {
  id?: number
  label?: string
}
export const dbGetProgram = (params: IDbGetProgramParam): Promise<IProgram | undefined> => {
  return dbData.transaction('r', dbData.program, () => {
    let filter = {}
    filter = Object.assign(filter, params.id != null ? { id: params.id } : {})
    filter = Object.assign(filter, params.label != null ? { label: params.label.toLowerCase } : {})

    if (Object.keys(filter).length) {
      return dbData.program.get(filter)
    } else {
      return Promise.resolve(undefined)
    }
  })
}

export const dbGetPrograms = async function (): Promise<Array<IProgram>> {
  const tabPrograms = await dbData.program.toArray()
  return tabPrograms ? tabPrograms : []
}

// ****************************************************************************** SET
export const dbSetPrograms = function (programs: Array<IProgram>) {
  return dbData.transaction('rw', dbData.program, async () => {
    if (await dbData.program.count() > 0) {
      await dbData.program.clear()
    }

    return dbData.program.bulkPut(programs).then(lastKey => lastKey).catch(err => {
      logger?.error('Error while inserting programs', err)
    })
  })
}

export const dbUpdateProgramComment = function (program: IProgram) {
  return dbData.transaction('rw', dbData.program, async () => {
    return dbData.program
      .where({ id: program.id })
      .modify({ comment: program.comment })
      .catch(err => {
        logger?.error('Error while updating the provided program', err)
      })
  })
}
